export default "__VITE_ASSET__B_Jn_JF1__"